import DraftContent from "./DraftContent";

export default DraftContent;